import React, { useEffect, useState } from 'react'
import VerificationInput from 'react-verification-input'
import './style.css'
import { useFormikContext } from 'formik'
import { AuthByCodeFields } from 'src/components/Forms/ManagerMandatForm/AuthByCode'
import { sendOtpCode } from 'src/services/authMandat'

interface CodeInputProps {
  duration?: number
  onConfirm?: () => void
}

const CodeInput: React.FC<CodeInputProps> = ({ duration = 5, onConfirm }) => {
  const [showResend, setShowResend] = useState(false)
  const [timeLeft, setTimeLeft] = useState(duration * 60)
  const form = useFormikContext<AuthByCodeFields>()
  const [messageError, setErrorMessage] = useState('')

  const reSendCode = async () => {
    try {
      const response = await sendOtpCode({ clientId: form.values.identifiant, email: form.values.email })
      if (response) {
        form.setFieldValue('code', [null, null, null, null, null, null])
        setErrorMessage('')
      }
    } catch (error) {
      setErrorMessage('une erreur est survenue.')
    }
  }

  useEffect(() => {
    if (timeLeft <= 0) {
      setShowResend(true)
      return
    }

    const timer = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1)
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft])

  return (
    <>
      <div style={{ flexDirection: 'column', alignItems: 'center', width: '90%' }} id="inscription">
        <h2>Saisissez le code de vérification reçu par SMS</h2>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '10px' }}>
        <VerificationInput
          placeholder=" "
          autoFocus
          validChars="z0-9"
          value={form.values.code.join('')}
          onChange={(value) => {
            form.setFieldValue('code', value.split('').map(Number))
          }}
          classNames={{
            character: 'character',
            characterInactive: 'character--inactive',
            characterSelected: 'character--selected',
            characterFilled: 'character--filled',
          }}
        />
        {messageError && <div style={{ color: 'rgb(210, 38, 48)' }}>{messageError}</div>}
      </div>
      {!showResend ? (
        <p style={{ marginTop: '10px', marginBottom: '5px', fontSize: '14px', color: '#707070' }}>
          Attention, votre code est valable {duration} min
        </p>
      ) : (
        <button
          style={{
            background: 'none',
            border: 'none',
            color: '#707070',
            cursor: 'pointer',
            fontSize: '14px',
            marginTop: '5px',
            textDecoration: 'underline',
          }}
          type="button"
          className="mb-5"
          onClick={() => {
            setShowResend(false)
            setTimeLeft(duration * 60)
            reSendCode()
          }}
        >
          Demander un nouveau code
        </button>
      )}

      <button
        style={{ width: '260px' }}
        className="cta my-2 flex-grow-0"
        type="button"
        onClick={onConfirm}
        disabled={form.values.code.join('').length !== 6}
      >
        Confirmer le code
      </button>
    </>
  )
}

export default CodeInput
